module.exports = __webpack_public_path__ + "img/prevention.b71489ad.png";